export interface BarSegment {
  label: string;
  value: number;
  color: string;
}

interface Props {
  segments: BarSegment[];
  height?: number;
  showLabels?: boolean;
}

export function StackedBar({ segments, height = 22, showLabels = false }: Props) {
  const total = segments.reduce((a, s) => a + s.value, 0) || 1;
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height,
        borderRadius: 4,
        overflow: "hidden",
        border: "1px solid var(--line-2)",
        background: "var(--bg-3)",
      }}
    >
      {segments.map((s, i) => (
        <div
          key={i}
          title={`${s.label}: ${s.value}`}
          style={{
            width: `${(s.value / total) * 100}%`,
            background: s.color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#0a0f17",
            fontFamily: "var(--mono)",
            fontSize: 10,
            fontWeight: 600,
            minWidth: s.value > 0 ? 18 : 0,
            transition: "width 400ms",
          }}
        >
          {showLabels && s.value > 0 && s.value}
        </div>
      ))}
    </div>
  );
}
